<template>
  <div class="page-create">
    <!-- banner -->
    <div class="section-banner section-box"></div>
    <!-- form -->
    <div class="section-form section-box">
      <div class="content-box">
        <van-form @submit="onSubmit" class="form-box">
          <van-field
            v-model="form.firstName"
            class="part"
            placeholder="First Name*"
            :rules="RULES.FirstName"
          />
          <van-field
            v-model="form.lastName"
            class="part"
            placeholder="Last Name*"
            :rules="RULES.LastName"
          />
          <van-field
            v-model="form.email"
            placeholder="Email Address*"
            :rules="RULES.Email"
          />
          <p class="label">Birthday</p>
          <p
            @click="dateshow = true"
            class="click-bt"
            :class="{ choose: isChooseDate }"
          >
            {{ form.birthday }}<i></i>
          </p>
          <van-field
            v-model="form.password"
            placeholder="Password*"
            :rules="RULES.Password"
            type="password"
          />
          <van-field
            v-model="form.repassword"
            placeholder="Confirm Password*"
            :rules="[
              {
                validator: validatorRepassword,
                message: 'password does not match, please retry',
              },
            ]"
            type="password"
          />
          <div class="policy-box">
            <i
              @click="isAgreePolicy = !isAgreePolicy"
              :class="{ active: isAgreePolicy }"
            ></i>
            <p class="text">
              I agree to platform’s
              <span @click="goPageByName('help', 'terms')"
                >Terms & Condition</span
              >
              and
              <span @click="goPageByName('help', 'privacy')"
                >Privacy Policy</span
              >
            </p>
          </div>
          <van-button class="sb-bt" round block type="info" native-type="submit"
            >CREATE MY ACCOUNT</van-button
          >
        </van-form>
      </div>
    </div>
    <!-- 日期 -->
    <van-popup class="popup-date" v-model="dateshow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="Birthday"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onDateConfirm"
        @cancel="dateshow = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { register } from "@/api/user";
import { goMembership, goPageByName } from "@/util/link";
import store from "@/store";
import RULES from "@/util/rules";

export default {
  name: "CreateView",
  data() {
    return {
      minDate: new Date(1980, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 1),
      isChooseDate: false,
      dateshow: false,
      form: {
        firstName: "",
        lastName: "",
        password: "",
        repassword: "",
        email: "",
        birthday: "2000-01-01",
      },
      isAgreePolicy: false,
      phonePattern: /^[0-9A-Za-z]{6,}$/,
      RULES,
    };
  },
  components: {},
  mounted() {
    console.log(this.$route.query);
    // goMembership();
  },
  methods: {
    handleChange() {},
    onSubmit() {
      if (this.form.password !== this.form.repassword) {
        this.$toast("Please enter the same password");
        return;
      }
      if (!this.isAgreePolicy) {
        this.$toast("Please select I Agree to register");
        this.isAgreePolicy = true;
        return;
      }
      this.register();
    },
    onDateConfirm(value) {
      const y = value.getFullYear();
      const m = value.getMonth() + 1;
      const d = value.getDate();
      const birthday = `${y}-${this.changeDate(m)}-${this.changeDate(d)}`;
      this.form.birthday = birthday;
      this.isChooseDate = true;
      this.dateshow = false;
    },
    // 注册
    async register() {
      const res = await register({
        birthday: this.form.birthday,
        email: this.form.email,
        firstName: this.form.firstName,
        lastName: this.form.lastName,
        password: this.form.password,
      });
      if (res.code === 0) {
        window.localStorage.setItem("authToken", res.data.authToken);
        window.localStorage.setItem("cardNo", res.data.cardNo);
        window.localStorage.setItem("email", res.data.email);
        window.localStorage.setItem("userId", res.data.userId);
        store.commit("setLoginState", true);
        goMembership({
          type: "success",
        });
      } else {
        this.$toast(res.msg);
      }
    },
    // 日期格式
    changeDate(value) {
      if (value <= 9) {
        return "0" + value;
      }
      return value;
    },
    goPageByName(name, type) {
      goPageByName({
        name,
        query: {
          type,
        },
      });
    },
    validatorRepassword(val) {
      return val === this.form.password;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-create {
  width: 100%;
  .section-banner {
    width: 100%;
    height: 3rem;
    position: relative;
    background: url("../assets/img/create/banner.png") no-repeat center;
    background-size: 100%;
  }
  .section-form {
    background: #f4f5f6;
    .content-box {
      width: 100%;
      padding: 0.5rem 0.3rem 1rem;
      box-sizing: border-box;
    }
    .form-box::v-deep {
      .van-cell {
        padding: 0;
        box-sizing: border-box;
        // height: 0.88rem;
        margin-bottom: 0.3rem;
        overflow: visible;
        background-color: #f4f5f6;
        vertical-align: top;
      }
      .part {
        width: 3.35rem;
        display: inline-block;
        &:first-child {
          margin-right: 0.2rem;
        }
      }
      .van-field--error .van-field__control {
        border: 1px solid #ff0000;
      }
      .van-field__control {
        height: 0.88rem;
        padding: 0.3rem 0 0.3rem 0.3rem;
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiR;
        color: #000000;
        box-sizing: border-box;
        border-radius: 0.08rem;
        border: 1px solid #cdcdcd;
      }
      .van-field__error-message {
        font-size: 0.24rem;
        font-family: AlibabaPuHuiTiR;
        color: #ff0000;
        line-height: 0.26rem;
        margin-top: 0.2rem;
        padding-left: 0.3rem;
      }
      .van-field--error .van-field__control,
      .van-field--error .van-field__control::placeholder {
        color: #666;
      }
      .van-field__control::placeholder {
        color: #666;
      }
      .label {
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiB;
        color: #000000;
        line-height: 0.38rem;
        text-align: left;
        margin-bottom: 0.2rem;
      }
      .van-radio-group--horizontal {
        margin-bottom: 0.5rem;
        justify-content: space-between;
      }
      .van-radio__label {
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiR;
        color: #000000;
        line-height: 0.38rem;
        margin-left: 0.2rem;
      }
      .van-radio {
        margin-right: 0;
      }
      .van-icon:before {
        display: none;
      }
      .van-icon {
        width: 0.34rem;
        height: 0.34rem;
        background: url("../assets/img/address/icon-k.png") no-repeat center;
        background-size: 100%;
        border: none;
      }
      .van-radio__icon--checked .van-icon {
        width: 0.34rem;
        height: 0.34rem;
        background: url("../assets/img/address/icon-x.png") no-repeat center;
        background-size: 100%;
      }
      .click-bt {
        width: 100%;
        height: 0.9rem;
        border-radius: 8px;
        border: 1px solid #cdcdcd;
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiR;
        color: #666666;
        padding: 0.25rem 0 0.25rem 0.3rem;
        box-sizing: border-box;
        text-align: left;
        position: relative;
        margin-bottom: 0.3rem;
        &.choose {
          color: #000;
        }
        i {
          width: 0.22rem;
          height: 0.12rem;
          background: url("../assets/img/address/icon-san.png") no-repeat center;
          background-size: 100%;
          position: absolute;
          top: 50%;
          right: 0.31rem;
          transform: translate3d(0, -50%, 0);
        }
      }
      .phone-box {
        position: relative;
        .van-cell {
          padding-left: 1rem;
          // padding: 0.3rem 0 0.3rem 0.3rem;
          height: 0.88rem;
          border-radius: 0.08rem;
          border: 1px solid #cdcdcd;
        }
        .van-field--error {
          margin-bottom: 1.22rem;
          border: 1px solid #ff0000;
        }
        .van-field__control {
          padding-left: 0;
          border: 0;
        }
      }
      .select {
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiR;
        color: #666666;
        line-height: 0.38rem;
        position: absolute;
        left: 0.3rem;
        top: 0.26rem;
      }
      .sb-bt {
        width: 6.9rem;
        height: 0.9rem;
        line-height: 0.9rem;
        background: #f4cc25;
        border-radius: 0.08rem;
        border: 1px solid #000000;
        font-size: 0.28rem;
        font-family: AlibabaPuHuiTiM;
        color: #000000;
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        margin-top: 0.2rem;
      }
    }
    .policy-box {
      margin-top: 0.3rem;
      padding-left: 0.54rem;
      position: relative;
      i {
        width: 0.34rem;
        height: 0.34rem;
        background: url("../assets/img/create/icon-k.png") no-repeat center;
        background-size: 100%;
        position: absolute;
        left: 0;
        top: 0.03rem;
        &.active {
          background: url("../assets/img/create/icon-x.png") no-repeat center;
          background-size: 100%;
        }
      }
      .text {
        font-size: 0.24rem;
        font-family: AlibabaPuHuiTiR;
        color: #000000;
        line-height: 0.36rem;
        text-align: left;
        span {
          font-family: AlibabaPuHuiTiM;
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
